/*
 * @Date: 2022-11-24 10:34:18
 * @LastEditors: 黄志伟 huangzhiwei04@saicmotor.com
 * @LastEditTime: 2024-01-11 14:34:33
 */
export default [
  {
    path: '/rent/v2/buy-sell-cars',
    name: 'buyAndSellCars',
    component: () => import('@/pages/secondHandCar/buyAndSellCars'),
    meta: { title: '咨询最低价', requireAuth: true },
  },
  {
    path: '/rent/v2/carIntroduction',
    name: 'carIntroduction',
    component: () => import('@/pages/secondHandCar/carIntroduction'),
    meta: { title: '车型介绍', requireAuth: true },
  },
  {
    path: '/rent/v2/rvPurchase',
    name: 'rvPurchase',
    component: () => import('@/pages/secondHandCar/rvPurchase'),
    meta: { title: '房车选购', requireAuth: true },
  },
  {
    path: '/rent/v2/sellCarHome',
    name: 'sellCarHome',
    component: () => import('@/pages/secondHandCar/sellCarHome'),
    meta: { title: '卖车', requireAuth: true },
  },
  {
    path: '/rent/v2/secondCarIndex',
    name: 'secondCarIndex',
    component: () => import('@/pages/secondHandCar/secondCarIndex'),
    meta: { title: '二手车', requireAuth: true },
  },
  {
    path: '/rent/v2/sellerAuth',
    name: 'sellerAuth',
    component: () => import('@/pages/secondHandCar/sellerAuth'),
    meta: { title: '卖家认证', requireAuth: true },
  },
  {
    path: '/rent/v2/authDetail',
    name: 'authDetails',
    component: () => import('@/pages/secondHandCar/authDetail'),
    meta: { title: '卖家认证', requireAuth: true },
  },
  {
    path: '/rent/v2/vehicleSource',
    name: 'vehicleSource',
    component: () => import('@/pages/secondHandCar/vehicleSource'),
    meta: { title: '发布车源', requireAuth: true },
  },
  {
    path: '/rent/v2/publishCar',
    name: 'publishCar',
    component: () => import('@/pages/secondHandCar/publishCar'),
    meta: { title: '发布车源', requireAuth: true },
  },
  {
    path: '/rent/v2/secondSearch',
    name: 'secondSearch',
    component: () => import('@/pages/secondHandCar/search'),
    meta: { title: '二手车搜索', requireAuth: true },
  },
  {
    path: '/rent/v2/chooseCarBrand',
    name: 'chooseCarBrand',
    component: () => import('@/pages/secondHandCar/chooseCarBrand'),
    meta: { title: '选择品牌', requireAuth: true },
  },
  {
    path: '/rent/v2/secondCarDetail',
    name: 'secondCarDetail',
    component: () => import('@/pages/secondHandCar/secondCarDetail'),
    meta: { title: '车辆详情', requireAuth: true },
  },
  {
    path: '/rent/v2/buyDemand',
    name: 'buyDemand',
    component: () => import('@/pages/secondHandCar/buyDemand'),
    meta: { title: '买车需求', requireAuth: true },
  },
  {
    path: '/rent/v2/requirementLog',
    name: 'requirementLog',
    component: () => import('@/pages/secondHandCar/requirementLog'),
    meta: { title: '需求记录', requireAuth: true },
  },
  {
    path: '/rent/v2/sellInfo',
    name: 'sellInfo',
    component: () => import('@/pages/secondHandCar/sellInfo'),
    meta: { title: '快速买卖', requireAuth: true },
  },
  {
    path: '/rent/v2/sellInfoLog',
    name: 'sellInfoLog',
    component: () => import('@/pages/secondHandCar/sellInfoLog'),
    meta: { title: '卖车需求记录', requireAuth: true },
  },
  {
    path: '/rent/v2/myCarList',
    name: 'myCarList',
    component: () => import('@/pages/secondHandCar/myCarList'),
    meta: { title: '我的车库', requireAuth: true },
  },
  {
    path: '/rent/v2/secondCarConfig',
    name: 'secondCarConfig',
    component: () => import('@/pages/secondHandCar/secondCarConfig'),
    meta: { title: '车辆配置', requireAuth: true },
  },
  {
    path: '/rent/v2/evaluate',
    name: 'evaluate',
    component: () => import('@/pages/secondHandCar/evaluate'),
    meta: { title: '车辆评估', requireAuth: true },
  },
  {
    path: '/rent/v2/secondMyCollect',
    name: 'secondMyCollect',
    component: () => import('@/pages/secondHandCar/secondMyCollect'),
    meta: { title: '我的收藏', requireAuth: true },
  },
  {
    path: '/rent/v2/secondReport',
    name: 'secondReport',
    component: () => import('@/pages/secondHandCar/secondReport'),
    meta: { title: '举报', requireAuth: true },
  },
  {
    path: '/rent/v2/chooseTHCity',
    name: 'chooseTHCity',
    component: () => import('@/pages/secondHandCar/chooseCity'),
    meta: { title: '选择城市', requireAuth: true },
  },
  {
    path: '/rent/v2/messageConfirm',
    name: 'messageConfirm',
    component: () => import('@/pages/secondHandCar/messageConfirm'),
    meta: { title: '信息确认', requireAuth: true },
  },
  {
      path: '/rent/v2/evaluateResult',
      name: 'evaluateResult',
      component: () => import('@/pages/secondHandCar/evaluateResult'),
      meta: { title: '房车估值报告', requireAuth: true },
  },
  {
      path: '/rent/v2/evaluateRecord',
      name: 'evaluateRecord',
      component: () => import('@/pages/secondHandCar/evaluateRecord'),
      meta: { title: '估价记录', requireAuth: true },
  },
  {
    path: '/rent/v2/mySecondCar',
    name: 'mySecondCar',
    component: () => import('@/pages/secondHandCar/mySecondCar'),
    meta: { title: '我的二手车', requireAuth: true },
},
]



// WEBPACK FOOTER //
// ./src/pages/secondHandCar/car.js